import { Component, OnInit, Input } from '@angular/core';
import { List } from 'immutable';
import { CompanyUvozNBS } from './company-uvoz-nbs';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BaseDataService, BaseCommonComponent, UserService, ModalService, CommonService, NotificationService } from 'yt-ng-framework';
// import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { CompanyEmail } from '../company-email/company-email';
import { CompanyTelefon } from '../company-telefon/company-telefon';
import { CompanyZrc } from '../company-zrc/company-zrc';
import { CompanyView } from '../company-view';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-company-uvoz-nbs',
  templateUrl: './company-uvoz-nbs.component.html'
})
export class CompanyUvozNbsComponent extends BaseCommonComponent implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected activeModal: NgbActiveModal,
    protected baseDataService: BaseDataService,
    // protected notificationService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService,
    protected userService: UserService,
    protected modalService: ModalService,
  ) { 
    super(activatedRoute, userService, baseDataService, translateService, modalService,toastrService);

  }

  emaili: List<CompanyEmail>;
  telefoni: List<CompanyTelefon>;
  ziroracuni: List<CompanyZrc>;
  itemsCompany: List<CompanyUvozNBS>;

  @Input() Parameters;

 

  gridEmailColumns = [];
  gridTelefonColumns = [];
  gridZiroracunColumns = [];

  itemEmail: CompanyEmail;
  itemTelefon: CompanyTelefon;
  itemZrc: CompanyZrc;

  submitted : boolean = false;
  loading : boolean = false;

  ngOnInit() {
    this.baseFormGroup = new FormGroup({
      EmailControl : new FormControl(''),
      TelefonControl : new FormControl(''),
      ZiroracunControl : new FormControl(''),
      Naziv : new FormControl(''),
      SNaziv : new FormControl(''),
      Pib : new FormControl(''),
      MaticniBroj : new FormControl(''),
      Adresa : new FormControl(''),
      MestoID : new FormControl(''),
      Web : new FormControl(''),
      LanguageID: new FormControl(''),
      ValutaID: new FormControl(1),
      Jbkjs: new FormControl('')
    })

    this.addValidatorToFc("Naziv",Validators.required,'required',"FIRMA.NAZIV.VALIDATION.REQUIRED");
    this.addValidatorToFc("Naziv", Validators.maxLength(200), 'maxlength', 'FIRMA.NAZIV.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("SNaziv",Validators.required,'required',"FIRMA.SNAZIV.VALIDATION.REQUIRED");
    this.addValidatorToFc("SNaziv", Validators.maxLength(100), 'maxlength', 'FIRMA.SNAZIV.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("Pib",Validators.required,'required',"FIRMA.PIB.VALIDATION.REQUIRED");
    this.addValidatorToFc("Pib", Validators.maxLength(9), 'maxlength', 'FIRMA.PIB.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("MaticniBroj",Validators.required,'required',"FIRMA.MATICNIBROJ.VALIDATION.REQUIRED");
    this.addValidatorToFc("MaticniBroj", Validators.maxLength(8), 'maxlength', 'FIRMA.MATICNIBROJ.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("Adresa",Validators.required,'required',"FIRMA.ADRESA.VALIDATION.REQUIRED");
    this.addValidatorToFc("Adresa", Validators.maxLength(200), 'maxlength', 'FIRMA.ADRESA.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("MestoID",Validators.required,'required',"FIRMA.MESTO.VALIDATION.REQUIRED");
    this.addValidatorToFc("LanguageID",Validators.required,'required',"FIRMA.JEZIK.VALIDATION.REQUIRED");
    this.addValidatorToFc("Jbkjs", Validators.maxLength(5), 'maxlength', 'FIRMA.JBKJS.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("ValutaID",Validators.required,'required',"FIRMA.VALUTA.VALIDATION.REQUIRED");

    this.itemsCompany = this.Parameters[0].Value;
    this.baseFormGroup.patchValue({Naziv : this.itemsCompany[0].Naziv});
    this.baseFormGroup.get('Naziv').updateValueAndValidity();
    this.baseFormGroup.patchValue({SNaziv : this.itemsCompany[0].SNaziv != '' ? this.itemsCompany[0].SNaziv : this.itemsCompany[0].Naziv});
    this.baseFormGroup.get('SNaziv').updateValueAndValidity();
    this.baseFormGroup.patchValue({Pib : this.itemsCompany[0].Pib});
    this.baseFormGroup.get('Pib').updateValueAndValidity();
    this.baseFormGroup.patchValue({MaticniBroj : new CommonService().PadLeft(this.itemsCompany[0].MaticniBroj, "0", 8)});
    this.baseFormGroup.get('MaticniBroj').updateValueAndValidity();
    this.baseFormGroup.patchValue({Adresa : this.itemsCompany[0].Adresa});
    this.baseFormGroup.get('Adresa').updateValueAndValidity();
    this.baseFormGroup.patchValue({MestoID : this.itemsCompany[0].MestoID});
    this.baseFormGroup.get('MestoID').updateValueAndValidity();
    this.baseFormGroup.patchValue({Web : this.itemsCompany[0].Web});
    this.baseFormGroup.get('Web').updateValueAndValidity();   
    // this.baseFormGroup.patchValue({LanguageID : this.itemsCompany[0].LanguageID});
    // this.baseFormGroup.get('LanguageID').updateValueAndValidity();    
    this.baseFormGroup.patchValue({Jbkjs : this.itemsCompany[0].Jbkjs});
    this.baseFormGroup.get('Jbkjs').updateValueAndValidity();  

    this.emaili = this.itemsCompany[0].Emaili;
    this.telefoni = this.itemsCompany[0].Telefoni;
    this.ziroracuni =  this.itemsCompany[0].ZiroRacuni;

    this.gridEmailColumns = this.Parameters[1].Value;
    this.gridTelefonColumns = this.Parameters[2].Value;
    this.gridZiroracunColumns = this.Parameters[3].Value;

  }

  Close(){
    this.activeModal.close();
  }

  async Save(){
    this.submitted = true;  
    if (this.baseFormGroup.valid) {
      this.loading = true;
      this.itemsCompany[0].Naziv = this.baseFormGroup.get('Naziv').value;
      this.itemsCompany[0].SNaziv = this.baseFormGroup.get('SNaziv').value;
      this.itemsCompany[0].Pib = this.baseFormGroup.get('Pib').value;
      this.itemsCompany[0].MaticniBroj = this.baseFormGroup.get('MaticniBroj').value;
      this.itemsCompany[0].Adresa = this.baseFormGroup.get('Adresa').value;
      this.itemsCompany[0].MestoID = this.baseFormGroup.get('MestoID').value;
      this.itemsCompany[0].Web = this.baseFormGroup.get('Web').value;
      this.itemsCompany[0].LanguageID = this.baseFormGroup.get('LanguageID').value;
      this.itemsCompany[0].ValutaID = this.baseFormGroup.get('ValutaID').value;
      this.itemsCompany[0].JBKJS = this.baseFormGroup.get('Jbkjs').value;

      let brojGlavnihTelefona : number = null;
      let brojGlavnihZiroRacuna : number = null;

      if (this.itemsCompany[0].Telefoni != null)
        brojGlavnihTelefona = this.checkBrojGlavnih(this.itemsCompany[0].Telefoni);
      
      if (this.itemsCompany[0].ZiroRacuni != null)
        brojGlavnihZiroRacuna = this.checkBrojGlavnih(this.itemsCompany[0].ZiroRacuni);

      if (this.itemsCompany[0].Telefoni != null && brojGlavnihTelefona > 1 || brojGlavnihTelefona == 0){
        this.translateService.get(['KOMITENT.UVOZNBS.VALIDATION.TITLE', 'KOMITENT.UVOZNBS.TELEFON.VALIDATION.CONTENT'])
          .subscribe(translate => {
            // this.notificationService.warn(translate['KOMITENT.UVOZNBS.VALIDATION.TITLE'], translate['KOMITENT.UVOZNBS.TELEFON.VALIDATION.CONTENT']);
            this.toastrService.warning(translate['KOMITENT.UVOZNBS.VALIDATION.TITLE'], translate['KOMITENT.UVOZNBS.TELEFON.VALIDATION.CONTENT']);
          });
        
        this.submitted = false;
        this.loading = false;
        return false;
      }

      if (this.itemsCompany[0].ZiroRacuni != null && brojGlavnihZiroRacuna > 1 || brojGlavnihZiroRacuna == 0){
        this.translateService.get(['KOMITENT.UVOZNBS.VALIDATION.TITLE', 'KOMITENT.UVOZNBS.ZIRORACUN.VALIDATION.CONTENT'])
          .subscribe(translate => {
            // this.notificationService.warn(translate['KOMITENT.UVOZNBS.VALIDATION.TITLE'], translate['KOMITENT.UVOZNBS.ZIRORACUN.VALIDATION.CONTENT']);
            this.toastrService.warning(translate['KOMITENT.UVOZNBS.VALIDATION.TITLE'], translate['KOMITENT.UVOZNBS.ZIRORACUN.VALIDATION.CONTENT']);
          });
          this.submitted = false;
          this.loading = false;
          return false;
      }

      if (this.checkGridData(this.itemsCompany[0].Emaili, this.gridEmailColumns, true)
        && this.checkGridData(this.itemsCompany[0].Telefoni, this.gridTelefonColumns, true)
        && this.checkGridData(this.itemsCompany[0].ZiroRacuni, this.gridZiroracunColumns, true)){    
          let noviID : number = -1;
          if(this.itemsCompany[0].ID == -1){
            await new Promise<void>((resolve, reject) =>{
            this.baseDataService.Post("Firma","post",this.itemsCompany[0],null)
            .subscribe((data : CompanyView[])=>{
              noviID = data["ID"];
              this.itemsCompany[0].ID = noviID;
              resolve();
            },
            error =>{
              this.translateService.get(['KOMITENT.UVOZNBS.INSERTKOMITENT.ERROR.TITLE'])
              .subscribe(translate => {
                // this.notificationService.warn(translate['KOMITENT.UVOZNBS.INSERTKOMITENT.ERROR.TITLE'], error.error);
                this.toastrService.warning(translate['KOMITENT.UVOZNBS.INSERTKOMITENT.ERROR.TITLE'], error.error);
              });
              this.submitted = false;
              this.loading = false;              
              return false;
            })
          })
        }
        else{
          await new Promise<void>((resolve, reject) =>{
            this.baseDataService.Post("Firma","post",this.itemsCompany[0],null)
            .subscribe(()=>{
              resolve();
            })
            
          })
        }
        if (this.itemsCompany[0].Emaili != null){
          for (let i = 0; i < this.itemsCompany[0].Emaili.length; i++){
            await new Promise<void>((resolve, reject) =>{
              this.itemEmail = new CompanyEmail();
              this.itemEmail.Deserialize(this.itemsCompany[0].Emaili[i]);
              this.itemEmail.FirmaID = this.itemsCompany[0].ID;
              this.itemEmail.ID = -1;
              this.baseDataService.Post("FirmaEmail","post",this.itemEmail,null)
                .subscribe(()=>{
                  resolve();
                },
                error =>{
                  this.translateService.get(['KOMITENT.UVOZNBS.INSERTKOMITENTEMAIL.ERROR.TITLE'])
                  .subscribe(translate => {
                    // this.notificationService.warn(translate['KOMITENT.UVOZNBS.INSERTKOMITENTEMAIL.ERROR.TITLE'], error.error + " "+ this.itemEmail.Naziv);
                    this.toastrService.warning(translate['KOMITENT.UVOZNBS.INSERTKOMITENTEMAIL.ERROR.TITLE'], error.error + " "+ this.itemEmail.Naziv);
                  });
                  this.submitted = false;
                  this.loading = false;              
                  return false;
                })
              
            })
          }
        }
        if (this.itemsCompany[0].Telefoni != null){
          for (let i = 0; i < this.itemsCompany[0].Telefoni.length; i++){
            await new Promise<void>((resolve, reject) =>{
              this.itemTelefon = new CompanyTelefon();
              this.itemTelefon.Deserialize(this.itemsCompany[0].Telefoni[i]);
              this.itemTelefon.FirmaID = this.itemsCompany[0].ID;
              this.itemTelefon.ID = -1;
              this.baseDataService.Post("firmaTelefon","post",this.itemTelefon,null)
                .subscribe(()=>{
                  resolve();
                },
                error =>{
                  this.translateService.get(['KOMITENT.UVOZNBS.INSERTKOMITENTTELEFON.ERROR.TITLE'])
                  .subscribe(translate => {
                    // this.notificationService.warn(translate['KOMITENT.UVOZNBS.INSERTKOMITENTTELEFON.ERROR.TITLE'], error.error + " "+ this.itemTelefon.Broj);
                    this.toastrService.warning(translate['KOMITENT.UVOZNBS.INSERTKOMITENTTELEFON.ERROR.TITLE'], error.error + " "+ this.itemTelefon.Broj);
                  });
                  this.submitted = false;
                  this.loading = false;              
                  return false;
                })
              
            })
          }
        }
        if (this.itemsCompany[0].ZiroRacuni != null){
          for (let i = 0; i < this.itemsCompany[0].ZiroRacuni.length; i++){
            await new Promise<void>((resolve, reject) =>{
              this.itemZrc = new CompanyZrc();  
              // this.itemZrc.Serialize(this.itemsKomitent[0].ZiroRacuni[i]);            
              this.itemZrc.Deserialize(this.itemsCompany[0].ZiroRacuni[i]);
              this.itemZrc.FirmaID = this.itemsCompany[0].ID;
              this.itemZrc.ID = -1;
              this.baseDataService.Post("FirmaZrc","post",this.itemZrc,null)
                .subscribe(()=>{
                  resolve();
                },
                error =>{
                  this.translateService.get(['KOMITENT.UVOZNBS.INSERTKOMITENTZRC.ERROR.TITLE'])
                  .subscribe(translate => {
                    // this.notificationService.warn(translate['KOMITENT.UVOZNBS.INSERTKOMITENTZRC.ERROR.TITLE'], error.error + " "+ this.itemZrc.Zrc);
                    this.toastrService.warning(translate['KOMITENT.UVOZNBS.INSERTKOMITENTZRC.ERROR.TITLE'], error.error + " "+ this.itemZrc.Zrc);
                  });
                  this.submitted = false;
                  this.loading = false;              
                  return false;
                })
              
            })
          }
        }
        this.submitted = false;
        this.loading = false;
        this.activeModal.close(this.itemsCompany[0].ID);
      }
      else{
        this.translateService.get(['KOMITENT.UVOZNBS.VALIDATION.TITLE', 'KOMITENT.UVOZNBS.VALIDATION.CONTENT'])
          .subscribe(translate => {
            // this.notificationService.warn(translate['KOMITENT.UVOZNBS.VALIDATION.TITLE'], translate['KOMITENT.UVOZNBS.VALIDATION.CONTENT']);
            this.toastrService.warning(translate['KOMITENT.UVOZNBS.VALIDATION.TITLE'], translate['KOMITENT.UVOZNBS.VALIDATION.CONTENT']);
          });
      }
    }
    
    
}

checkGridData(items: List<any>, gridTableColumns: any[], mozePrazanItems: boolean):boolean{
  if (items){
    let itemsPropertyName = Object.keys(items[0]);
    let _required:boolean = false;
    let retVal:boolean = true;

    for (let i = 0; i < itemsPropertyName.length; i++){
      for (let j = 0; j < gridTableColumns.length; j++){
        if (itemsPropertyName[i] == gridTableColumns[j]["name"]){
          _required = gridTableColumns[j]["required"] == "true" ? true : false;
          if(_required){
            for (let k = 0; k < items["length"]; k++){
              retVal = true;
              switch(gridTableColumns[j]["type"]){
                case "DDL":
                  if (items[k][itemsPropertyName[i]] == null){
                    retVal = false;
                  }
                  break;
                case "number":
                  if (items[k][itemsPropertyName[i]] == 0){
                    retVal = false;
                  }
                  break;
                case "input":
                  if (items[k][itemsPropertyName[i]] == ""){
                    retVal = false;
                  }
                  break;
              }
              if (retVal == false)
                return retVal;
            }
          }
        }
      }         

    }
    return retVal;
  }
  else{
    if (mozePrazanItems)
      return true;
    else
      return false;
  } 
}

checkBrojGlavnih(items: List<any>):number{
  let array = Array.from(items);
  let brojGlavnih : number;

  if (items){
    brojGlavnih = array.filter(function(value){
      return value["Glavni"] === true;
  }).length
    
  }
  return brojGlavnih;
}



}
